<template>
  <div id="descuentos-temporales">
    <div class="sub-seccion" v-if="!deshabilitado || descuentos_temporales_copy.length">
      <div class="titulo-sub-seccion">
        <span>Descuentos temporales</span>
      </div>
      <div class="contenido-sub-seccion">
        <v-container v-if="descuentos_temporales_copy.length" class="pa-2">
          <div
            class="d-flex justify-space-between align-center container-descuento"
            v-for="(descuento_temporal, index_descuento_temporal) in this.descuentos_temporales_copy" :key="index_descuento_temporal"
          >
            <div class="d-flex">
              <v-text-field
                v-model="descuento_temporal.meses"
                :label='index_descuento_temporal === 0 ? "Primeros" : "Próximos"'
                value=descuento_temporal.meses
                type="number"
                class="input-descuento"
                suffix="meses"
                :rules="regla_meses(descuento_temporal.meses)"
                :disabled="deshabilitado"
                :min="1"
              >
              </v-text-field>

              <v-text-field
                v-model="descuento_temporal.descuento"
                label="Descuento"
                value=descuento_temporal.descuento
                type="number"
                class="input-descuento"
                :rules="reglas_descuentos(descuento_temporal.descuento)"
                :disabled="deshabilitado"
                :min="0"
                :max="100"
              >
                <div slot="append">
                  <v-icon :class="deshabilitado ? 'deshabilitado' : ''">percent</v-icon>
                </div>
              </v-text-field>
            </div>

            <v-icon class="icon-delete mr-4" v-if="!deshabilitado" @click="borrarDescuentoTemporal(index_descuento_temporal)">delete</v-icon>
          </div>
        </v-container>

        <div class="ml-2" v-if="!deshabilitado">
          <a class="label-agregar-descuento" @click="agregarDescuentoTemporal()">Agregar descuento</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DescuentosTemporales',

  props: {
    descuentos_temporales: { type: Array, default: () => [] }, // Arreglo de descuentos temporales
    deshabilitado: { type: Boolean, default: false } // Flag para deshabilitar los inputs
  },

  data() {
    return {
      descuentos_temporales_copy: [], // Copia de la prop, para actualizarla emitiendo evento

      // Reglas para la validación
      reglas_descuentos: (valor) => [(valor > 0 && valor <= 100) || 'El descuento debe ser mayor a 0 y menor a 100'],
      regla_meses: (valor) => [valor >= 1 || 'El valor debe ser mayor que 0'],
    };
  },

  watch: {

    /**
     * Necesario para actualizar los descuentos en el padre con los cambios hechos en este componente
     */
    descuentos_temporales_copy: {
      handler: function (new_value) {
        this.$emit('update:descuentos_temporales', new_value);
      },
      deep: true,
    },
  },

  mounted() {
    this.descuentos_temporales_copy = _.cloneDeep(this.descuentos_temporales); // Lo clono para poder modificarlos
  },

  methods: {

    /**
     * Crea un descuento temporal default y se inserta en el arreglo, haciendo asi que se renderize un nuevo input en el template
     */
    agregarDescuentoTemporal(){
      this.descuentos_temporales_copy.push({'meses': 1, 'descuento': 1});
    },

    /**
     * Borra del arreglo de descuentos temporales el descuento con ese indice, lo cual provoca renderiza del template
     *
     * @param {Integer} indice
     */
    borrarDescuentoTemporal(indice){
      this.descuentos_temporales_copy.splice(indice, 1);
    },

    /**
     * Actualiza la copia de los descuentos temporales con los cambios hechos en el padre 
     */
    actualizarDescuentosTemporales(nuevos_descuentos_temporales) {
      this.descuentos_temporales_copy = _.cloneDeep(nuevos_descuentos_temporales);
    }
  }

};
</script>

<style lang="scss">
#descuentos-temporales {
  .container-descuento{
    background-color: color(fondo-claro);
    margin-bottom: 8px;
  }

  .input-descuento {
    max-width: 85px;
    margin-left: 16px;
    margin-right: 16px;
  }

  .deshabilitado{
    color:color(gris-deshabilitado);
  }

  // Desplazo las flechas del input number
  .input-descuento input::-webkit-outer-spin-button,
  .input-descuento input::-webkit-inner-spin-button {
      margin-left:5px;
  }
}
</style>